import { adhd } from './adhd';
import { alcohol } from './alcohol';
import { anxiety } from './anxiety';
import { circulation } from './circulation';
import { depression } from './depression';
import { digitalhealth } from './digitalHealth';
import { drinkfree } from './drinkfree';
import { flexibility } from './flexibility';
import { healthCheck } from './healthCheck';
import { heart } from './heart';
import { imunity } from './imunity';
import { insomnia } from './insomnia';
import { intimateHealth } from './intimateHealth';
import { liver } from './liver';
import { movement } from './movement';
import { nicotine } from './nicotine';
import { skin } from './skin';
import { sleephealth } from './sleepHealth';
import { wellbeing } from './wellbeing';
import { workbalance } from './workbalance';
import { foodstyle } from './foodstyle';
import { longevity } from '@/store/staticForms/tally/longevity/index.js';

export const tally = {
  modules: {
    adhd,
    alcohol,
    anxiety,
    circulation,
    depression,
    digitalhealth,
    drinkfree,
    flexibility,
    foodstyle,
    healthCheck,
    heart,
    imunity,
    insomnia,
    intimateHealth,
    liver,
    longevity,
    movement,
    nicotine,
    skin,
    sleephealth,
    wellbeing,
    workbalance
  },
  namespaced: true
};
